import JobsCard from "./JobsCard";
export default function JobsCardPage({ jobs }) {
  return (
    <>
      <div className="jobs-card-wrapper">
        <JobsCard jobs={jobs} />
      </div>
    </>
  );
}
